import OutlineButtonComponent from '@components/buttons/OutlineButton';
import PrimaryButtonComponent from '@components/buttons/PrimaryButton';
import CloseIconComponent from '@components/icons/closeIcon';
import { ModalComponent } from '@components/modal/Modal';
import { medium_2xl, regular_base } from '@components/web/texts/Styles';
import { Button1Text } from '@components/web/texts/Texts';
import { APPLY_SOLUTION_MODAL_QUERY_PARAM } from '@utils/constants';
import { useRouter } from 'next/router';

export function ConfirmApplySolutionModal({
  confirm,
}: {
  confirm: () => void;
}) {
  const router = useRouter();

  function hideModal() {
    const { pathname, query } = router;
    delete router.query[APPLY_SOLUTION_MODAL_QUERY_PARAM];
    router.replace({ pathname, query }, undefined, {
      shallow: true,
    });
  }

  return (
    <ModalComponent
      handleHideModal={hideModal}
      className="relative flex w-full max-w-[440px] flex-col rounded-3xl bg-product2-background-secondary p-8"
    >
      <button
        className={`absolute right-4 top-4 h-8 rounded-lg px-1 hover:bg-product2-background-tertiary`}
        onClick={hideModal}
      >
        <CloseIconComponent className="h-6 w-6 text-product2-content-secondary" />
      </button>
      <h2 className={`${medium_2xl} text-center`}>Use provided solution?</h2>
      <p className={`mt-4 text-center ${regular_base}`}>
        If you proceed, we&apos;ll replace your code with the provided solution
      </p>
      <div className="mt-8 flex space-x-2">
        <OutlineButtonComponent
          onClick={hideModal}
          className="flex-1 rounded-xl py-2 hover:bg-product2-background-tertiary"
        >
          <Button1Text>Cancel</Button1Text>
        </OutlineButtonComponent>
        <PrimaryButtonComponent
          onClick={() => {
            confirm();
            hideModal();
          }}
          className="flex-1 rounded-xl bg-product2-background-accent py-2 hover:bg-product2-background-accentLight"
        >
          <Button1Text>Use solution</Button1Text>
        </PrimaryButtonComponent>
      </div>
    </ModalComponent>
  );
}
